/* Warning: please do not statically import any dependencies here except for static assets like icons */
// import icon from './file-code-solid.svg'

const tpsdwan_mgt_init = ({ vars, onAuthed, sparkyFramework }) => {

    return Promise.resolve(import( './RoutesManager.js').then(r => r.default))
};

export default tpsdwan_mgt_init;
